<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
        </div>
        <div class="row">
            <!-- Broj vožnje -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            #autofocus name="txtBrojVoznje"
                            [Label]="'EOTPREMNICAPREVOZ.BROJVOZNJE.SINGULAR'"
                            formControlName="BrojVoznje"
                            [FormatString]="'1.0-0'"
                        >
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>            
            <!-- Naziv prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.NAZIVPREVOZNIKA.SINGULAR'"
                            formControlName="NazivPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Registarski broj -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.REGISTARSKIBROJPREVOZNIKA.SINGULAR'"
                            formControlName="RegistarskiBrojPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>                      
        </div>
        <div class="row">
            <!-- Ulica prevoznika -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.ULICAPREVOZNIKA.SINGULAR'"
                            formControlName="UlicaPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Broj u ulici prevoznika -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.BROJUULICIPREVOZNIKA.SINGULAR'"
                            formControlName="BrojUUliciPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Poštanski broj prevoznika -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.POSTANSKIBROJPREVOZNIKA.SINGULAR'"
                            formControlName="PostanskiBrojPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Grad prevoznika -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.GRADPREVOZNIKA.SINGULAR'"
                            formControlName="GradPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- Dodatno ulica prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.DODATNOULICAPREVOZNIKA.SINGULAR'"
                            formControlName="DodatnoUlicaPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Pib prevoznika -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.PIBPREVOZNIKA.SINGULAR'"
                            formControlName="PibPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Matični broj prevoznika -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.MATICNIBROJPREVOZNIKA.SINGULAR'"
                            formControlName="MaticniBrojPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- Pocetna lokacija prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR'"
                            formControlName="PocetnaLokacijaPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>            
            <!-- Pretovarna tačka prevoznika -->
            <div class="col-lg-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR'"
                            formControlName="PretovarnaTackaPrevoznika"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>            
        </div>
        <div class="row">
            <!-- Ime vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.IMEVOZACA.SINGULAR'"
                            formControlName="ImeVozaca"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>            
            <!-- Prezime vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.PREZIMEVOZACA.SINGULAR'"
                            formControlName="PrezimeVozaca"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>            
            <!-- Telefon vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.TELEFONVOZACA.SINGULAR'"
                            formControlName="TelefonVozaca"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>            
 
        </div>
        <div class="row">
            <!-- E-mail vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.EMAILVOZACA.SINGULAR'"
                            formControlName="EmailVozaca"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>  
            <!-- Tip Dokumenta vozača -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.TIPDOKUMENTAVOZACA.SINGULAR'"
                            formControlName="TipDokumentaVozaca"
                        >
                        </yt-input>
                    </div>
                </div>
            </div> 
                        <!-- Broj vozacke dozvole -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICAPREVOZ.VOZACBROJVOZACKEDOZVOLE.SINGULAR'"
                            formControlName="VozacBrojVozackeDozvole"
                            [ngClass]="{'is-invalid': submitted && fc.VozacBrojVozackeDozvole.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.VozacBrojVozackeDozvole.invalid">
                            <span *ngFor="let validation of errorMessages.VozacBrojVozackeDozvole">
                                <span class="error-message"
                                    *ngIf="fc.VozacBrojVozackeDozvole.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>                        
        </div>                 
    </form>
</div>